import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AlumniNavigation from '../Inc/AlumniNavigation';
import { Icon, Button, Tabs, Select, Row, Col, Spin } from 'antd';
import './style.css';
import * as actions from '../../actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment'

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

class Events extends Component {

    constructor(props) {
        super(props);
        this.getevents = this.getevents.bind(this)
        this.getcurrentevents = this.getcurrentevents.bind(this)
    }

    componentDidMount = () => {
        this.props.actions.getevents()
    }

    getcurrentevents = () => {
        if (!this.props.events) {
            return <div>
            <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Events..." />
          </div>
        }
        else {
            let events = this.props.events.events
            let eventsinCurrentMonth = 0
            return events.map(function (eventdet, i) {
                let isCurrentMonth = moment(eventdet.start_date).isSame(new Date(), 'month')
                if (isCurrentMonth) {
                    eventsinCurrentMonth++
                    return (
                        <div key={i}>
                            <div className='widget event-card'>
                                <div className='widget-layout padding-15'>
                                    <Row type='flex' align='center' justify='center' className='min-height-200'>
                                        <Col className='eventDateDiv' span={5}>
                                            <span className="EagleEventDay">
                                                {moment(eventdet.start_date).format('dddd')}
                                            </span>
                                            <span className="EagleEventDate">
                                                {moment(eventdet.start_date).format('MMM DD')}
                                            </span>
                                        </Col>
                                        <Col span={19} className='event-content-div'>
                                            <Col span={24} className='text-left'>
                                                <div className='ad-event-name' dangerouslySetInnerHTML={{ __html: eventdet.title }} />
                                            </Col>
                                            <Col span={24} className='text-left'>
                                                <span className='ad-event-date'> <i className="fa fa-calendar"></i> {eventdet.start_date} to {eventdet.end_date} </span>
                                            </Col>
                                            <Col span={24} className='text-left'>
                                                <span className='ad-event-date'> <i className="fa fa-map-marker"></i> {eventdet.venue.length != 0 ? eventdet.venue.venue : "-"} </span>
                                            </Col>
                                            <Col span={24} className='text-justify margin-top-10'>
                                                <div className='ad-event-des' dangerouslySetInnerHTML={{ __html: eventdet.description }} />
                                            </Col>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    )
                }
                if (eventsinCurrentMonth == 0) {
                    eventsinCurrentMonth++
                    return (
                        <div>
                            <Row type='flex' align='center' justify='center' className='min-height-200'>
                                <Col span={24}>
                                    <div className='eventDateDiv'>
                                        <span>No Events!</span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )
                }

            })
        }
    }


    getevents = () => {
        if (!this.props.events) {
            return <div>
            <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Events..." />
          </div>
        }
        else {
            let events = this.props.events.events
            return events.map(function (eventdet, i) {
                let isCurrentMonth = moment(eventdet.start_date).isSame(new Date(), 'month')
                if (!isCurrentMonth) {
                    return (
                        <div key={i}>
                            <div className='widget event-card'>
                                <div className='widget-layout padding-15'>
                                    <Row type='flex' align='center' justify='center' className='min-height-200'>
                                        <Col className='eventDateDiv' span={5}>
                                            <span className="EagleEventDay">
                                                {moment(eventdet.start_date).format('dddd')}
                                            </span>
                                            <span className="EagleEventDate">
                                                {moment(eventdet.start_date).format('MMM DD')}
                                            </span>
                                        </Col>
                                        <Col span={19} className='event-content-div'>
                                            <Col span={24} className='text-left'>
                                                <div className='ad-event-name' dangerouslySetInnerHTML={{ __html: eventdet.title }} />
                                            </Col>
                                            <Col span={24} className='text-left'>
                                                <span className='ad-event-date'> <i className="fa fa-calendar"></i> {eventdet.start_date} to {eventdet.end_date} </span>
                                            </Col>
                                            <Col span={24} className='text-left'>
                                                <span className='ad-event-date'> <i className="fa fa-map-marker"></i> {eventdet.venue.length != 0 ? eventdet.venue.venue : "-"} </span>
                                            </Col>
                                            <Col span={24} className='text-justify margin-top-10'>
                                                <div className='ad-event-des' dangerouslySetInnerHTML={{ __html: eventdet.description }} />
                                            </Col>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </div>
                    )
                }
            })
        }
    }

    render() {
        return (
            <div>
                <LayoutHeader />
                <AlumniNavigation />
                <div className="widget">
                    <div className="events-container">
                        <Tabs tabPosition="left">
                            <TabPane tab="Current Month Events" key="1">
                                {this.getcurrentevents()}
                            </TabPane>
                            <TabPane tab="Upcoming All Events" key="2">
                                {this.getevents()}
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        events_loading: state.eventreducer.lodaing,
        events: state.eventreducer.events
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}


export default connect(mapStateToProps, mapDispatchToProps)(Events);



// WEBPACK FOOTER //
// ./src/components/Events/index.js